const ITEMS = [
  "PERMANENT RECRUITMENT",
  "TEMPORARY STAFFING",
  "EXECUTIVE SEARCH",
  "IT RECRUITMENT",
  "HR CONSULTING",
  "RESUME WRITING",
  "INTERVIEW PREPARATION",
  "CAREER COUNSELING",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="py-6 border-y border-black/10 overflow-hidden bg-white" data-testid="services-marquee">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-bold text-xl md:text-2xl tracking-tight text-[#0A1128] px-6">{item}</span>
            <span className="w-2 h-2 bg-[#1D4ED8] rotate-45" />
          </span>
        ))}
      </div>
    </div>
  );
}
